<script>
export default {
  name: 'GradeItem',
};
</script>

<template>
<div class="">
  <div class="text-center">
    <h1>Grade Item</h1>
  </div>
  <b-card
    class="mb-2 p-2"
    no-body
    style="border: 0.1rem solid gray;"
  >
    <b-row>
      <b-col>
        <span>ID Item: </span> <pre>{{ $route.params.item.Descricao }}</pre>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-center">
        <b-img
          src="https://picsum.photos/500/300/?image=25"
          fluid
          alt="Fluid image"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-center">
        <b-button
          variant="primary"
        >
          Selecionar
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</div>
</template>

<style scoped lang="scss">

</style>
